const dateTimeFormat = new Intl.DateTimeFormat("fr-FR", {
  hour: "numeric",
  minute: "numeric",
  year: "numeric",
  month: "long",
  day: "numeric",
});

const dateFormat = new Intl.DateTimeFormat("fr-FR", {
  year: "numeric",
  month: "numeric",
  day: "numeric",
});

const shortDateFormat = new Intl.DateTimeFormat("fr-FR", {
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
});

const shortDateWithMonthLetter = new Intl.DateTimeFormat("fr-FR", {
  year: "numeric",
  month: "short",
  day: "2-digit",
});

const dateWithDayFormat = new Intl.DateTimeFormat("fr-FR", {
  year: "numeric",
  month: "long",
  day: "numeric",
  weekday: "long",
});

const dateWithoutDayFormat = new Intl.DateTimeFormat("fr-FR", {
  year: "numeric",
  month: "long",
  day: "numeric",
});

const shortDateWithDayFormat = new Intl.DateTimeFormat("fr-FR", {
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
  weekday: "short",
});

const timeFormat = new Intl.DateTimeFormat("fr-FR", {
  hour: "numeric",
  minute: "numeric",
});

const Label = ({ date, format }: LabelType) => {
  if (!date) {
    return "-";
  }
  const _date = new Date(date);
  return <time dateTime={_date.toISOString()}>{format.format(_date)}</time>;
};

type LabelType = {
  date?: number | string | Date | null;
  format: any;
};

export const DateLabel = ({ date }: DateLabelType) => (
  <Label date={date} format={dateFormat} />
);
type DateLabelType = {
  date: LabelType["date"];
};

export const ShortDateLabel = ({ date }: ShortDateLabelType) => (
  <Label date={date} format={shortDateFormat} />
);
type ShortDateLabelType = {
  date: LabelType["date"];
};

export const ShortDateWithMonthLetter = ({
  date,
}: ShortDateWithMonthLetterType) => (
  <Label date={date} format={shortDateWithMonthLetter} />
);
type ShortDateWithMonthLetterType = {
  date: LabelType["date"];
};

export const DateWithDayLabel = ({ date }: DateWithDayLabelType) => (
  <Label date={date} format={dateWithDayFormat} />
);
type DateWithDayLabelType = {
  date: LabelType["date"];
};

export const DateWithoutDayLabel = ({ date }: DateWithoutDayLabelType) => (
  <Label date={date} format={dateWithoutDayFormat} />
);
type DateWithoutDayLabelType = {
  date: LabelType["date"];
};

export const ShortDateWithDayLabel = ({ date }: ShortDateWithDayLabelType) => (
  <Label date={date} format={shortDateWithDayFormat} />
);
type ShortDateWithDayLabelType = {
  date: LabelType["date"];
};

export const TimeLabel = ({ date }: TimeLabelType) => (
  <Label date={date} format={timeFormat} />
);
type TimeLabelType = {
  date: LabelType["date"];
};

export const DateTimeLabel = ({ date }: DateTimeLabelType) => (
  <Label date={date} format={dateTimeFormat} />
);
type DateTimeLabelType = {
  date: LabelType["date"];
};

export default DateTimeLabel;

export const DateRange = ({
  defaultMessage,
  start,
  end = null,
}: DateRangeType) => {
  const today = new Date();

  if (!start && !end) {
    return defaultMessage ?? "Choisir une période";
  }

  if (!end || isSameDay(start, end)) {
    return isSameDay(today, start) ? (
      "Aujourd'hui"
    ) : (
      <Label date={start} format={shortDateFormat} />
    );
  }

  return (
    <>
      {isSameDay(today, start) ? (
        "Aujourd'hui"
      ) : (
        <Label date={start} format={shortDateFormat} />
      )}
      &nbsp;-&nbsp;
      {isSameDay(today, end) ? (
        "Aujourd'hui"
      ) : (
        <Label date={end} format={shortDateFormat} />
      )}
    </>
  );
};
type DateRangeType = {
  start: LabelType["date"];
  end?: LabelType["date"];
  defaultMessage: string;
};

function isSameDay(d1, d2) {
  return (
    d1.getFullYear() === d2.getFullYear() &&
    d1.getMonth() === d2.getMonth() &&
    d1.getDate() === d2.getDate()
  );
}
